module.exports = __webpack_public_path__ + "img/ozgur-photo-small-round.765395b4.png";